import { propertyCategoryMapper } from "apps/propertySelection/propertyCategory/constants";
import { PropertyTypePage } from "apps/propertySelection/propertyType/Page";

export default PropertyTypePage(propertyCategoryMapper.Unique);
